export const prepend = ({ string, prefix }) => {
    if (!string || !prefix) {
        return string;
    }
    return string.startsWith(prefix) ? string : prefix + string;
};
